
jQuery(document).ready(function () {
    var handle_drill_pattern = jQuery("#_project_cabinet_handle_drill_pattern");
    var no_handle = jQuery("#form_input_No_Handle");

    if (handle_drill_pattern.val() == "No Drilling") {
        no_handle.hide();
    } else {
        no_handle.show();
    }

});